import { useCallback } from 'react';
import { CustomContent, FieldOptionsWithFallback, ImagePosition } from '../types';
import { isImagePosition } from '../utils';
import { useContentBlockFieldParser } from './useContentBlockFieldParser';

export const useContentBlockImagePosition = (
  customContent: CustomContent[],
  { slug, fallback }: FieldOptionsWithFallback<ImagePosition>
) => {
  const parser = useCallback((i: string) => (isImagePosition(i) ? i : fallback), [fallback]);
  const position = useContentBlockFieldParser(customContent, 'img-pos', {
    slug,
    parser
  });
  return { position, flipped: position !== fallback };
};
